import { render, staticRenderFns } from "./TopVesselsByCustomerReport.vue?vue&type=template&id=1a8d40e3&scoped=true&"
import script from "./TopVesselsByCustomerReport.vue?vue&type=script&lang=js&"
export * from "./TopVesselsByCustomerReport.vue?vue&type=script&lang=js&"
import style0 from "./TopVesselsByCustomerReport.vue?vue&type=style&index=0&id=1a8d40e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d40e3",
  null
  
)

export default component.exports